'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLatLngDistance = getLatLngDistance;
exports.isInPolygon = isInPolygon;
exports.localizedDistance = localizedDistance;
exports.i18nDistance = i18nDistance;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxLat = 90,
    minLat = -90,
    maxLng = 180,
    minLng = -180,
    earthRadius = 3958.75,
    meterConversion = 1609;

function getLatLngDistance(latlng1, latlng2) {
    return getDistance(latlng1.lat, latlng1.lng, latlng2.lat, latlng2.lng);
}

function isInPolygon(pol, point) {
    var i, j;
    var c = false;
    var nvert = pol.length;
    var lat = point.lat;
    var lng = point.lng;

    for (i = 0, j = nvert - 1; i < nvert; j = i++) {
        var vertex1 = pol[i];
        var vertex2 = pol[j];

        if (vertex1.lng < lng && vertex2.lng >= lng || vertex2.lng < lng && vertex1.lng >= lng) {
            if (vertex1.lat + (lng - vertex1.lng) / (vertex2.lng - vertex1.lng) * (vertex2.lat - vertex1.lat) < lat) {
                c = !c;
            }
        }
    }

    return c;
}

function localizedDistance(meters, countryCode) {
    var units = { 'km': 1000, 'mi': 1609.344 };
    var kiloUnit = _lodash2.default.includes(['US', 'LR', 'MM'], countryCode) ? 'mi' : 'km';

    return {
        unit: kiloUnit,
        value: meters / units[kiloUnit]
    };
}

function i18nDistance(meters, countryCode, i18n) {
    var precision = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    var _localizedDistance = localizedDistance(meters, countryCode),
        unit = _localizedDistance.unit,
        value = _localizedDistance.value;

    value = parseInt(value * precision * 10) / (precision * 10);

    var txt = void 0;

    switch (unit) {
        case 'km':
            {
                txt = i18n.get('distances_km', '${params.value} km', {
                    params: {
                        value: value
                    }
                });
            }
            break;

        case 'mi':
            {
                txt = i18n.get('distances_mi', '${params.value} mi', {
                    params: {
                        value: value
                    }
                });
            }
            break;
    }

    return txt;
}

function getDistance(lat1, lng1, lat2, lng2) {
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);

    return earthRadius * meterConversion * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function toRad(n) {
    return n * Math.PI / 180;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/GeoUtils.js
// module id = 1128
// module chunks = 0